import React from 'react';
import { twMerge } from 'tailwind-merge';

export default function SfxTag(props: { className?: string }) {
  return (
    <span
      className={twMerge(
        'bg-green-700 rounded-full px-2 py-0.5 text-white text-xs uppercase',
        props.className
      )}
    >
      SFX
    </span>
  );
}
